import { Icon, IconProps } from './Icon';

interface TripIconProps extends IconProps {
  gradient?: {
    id: string;
    stops: { offset: string; color: string }[];
  };
}

export const TripIcon = ({ color = '#BDC9EE', gradient, ...props }: TripIconProps) => (
  <Icon
    {...props}
    viewBox="0 0 29 28"
  >
    {gradient && (
      <defs>
        <linearGradient
          id={gradient.id}
          x1="80%"
          y1="20%"
          x2="20%"
          y2="80%"
        >
          {gradient.stops.map((stop, index) => (
            <stop
              key={index}
              offset={stop.offset}
              stopColor={stop.color}
            />
          ))}
        </linearGradient>
      </defs>
    )}
    <defs>
      <clipPath id="clip0_6677_9399">
        <rect
          width="28"
          height="28"
          fill="white"
          transform="translate(0.5)"
        />
      </clipPath>
    </defs>
    <g clipPath="url(#clip0_6677_9399)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.55505 17.0752C1.37389 16.7603 1.48059 16.3574 1.79308 16.1764C2.41806 15.8143 2.95557 15.3454 3.41327 15.5526L6.24071 16.8008L12.3379 12.5073L5.67869 6.99803C5.29599 6.69496 5.35939 6.08097 5.82303 5.89107L8.31076 4.7384C8.47833 4.66756 8.69119 4.67543 8.8681 4.75661L17.9698 9.03455C19.9423 7.89171 25.0893 5.25084 26.559 7.44314L26.6043 7.52185C27.7728 9.91487 22.9202 13.0674 20.9476 14.2102L20.0887 24.2589C20.0703 24.4533 19.9707 24.6422 19.8144 24.7327L17.5398 26.3916C17.1297 26.6293 16.6185 26.3744 16.5596 25.91L15.1346 17.3682L8.36934 20.5005L8.04417 23.6015C7.98275 24.0831 7.32069 24.3355 6.69572 24.6976C6.34417 24.9012 5.88958 24.7448 5.72682 24.2356C4.34969 20.2579 4.38677 20.3676 1.64251 17.182C1.60034 17.1539 1.57769 17.1146 1.55505 17.0752Z"
        fill={gradient ? `url(#${gradient.id})` : color}
      />
    </g>
  </Icon>
);
